import RiderConfirmCode from './index.vue'
const routes = [
  {
    path: '/rider-confirm-code',
    name: 'riderConfirmCode',
    component: RiderConfirmCode,
  },
]

export default routes
